export default "/JMMMU/image_translation.6b567a2b-2f6675.png";